/**
 * @generated SignedSource<<51ee8fc040ec19656eccfaed51bffbee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MondayImportExistingTicketPanePreviewQuery$variables = {
  assigneeColumnId?: string | null;
  dueDateColumnId?: string | null;
  itemId: string;
  statusColumnId?: string | null;
};
export type MondayImportExistingTicketPanePreviewQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly monday: {
        readonly itemPreview: {
          readonly assignee: {
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
          } | null;
          readonly done: boolean | null;
          readonly due: string | null;
          readonly externalId: string | null;
          readonly id: string;
          readonly name: string;
        } | null;
      } | null;
    };
  };
};
export type MondayImportExistingTicketPanePreviewQuery = {
  response: MondayImportExistingTicketPanePreviewQuery$data;
  variables: MondayImportExistingTicketPanePreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assigneeColumnId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dueDateColumnId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "statusColumnId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "assigneeColumnId",
      "variableName": "assigneeColumnId"
    },
    {
      "kind": "Variable",
      "name": "dueDateColumnId",
      "variableName": "dueDateColumnId"
    },
    {
      "kind": "Variable",
      "name": "itemId",
      "variableName": "itemId"
    },
    {
      "kind": "Variable",
      "name": "statusColumnId",
      "variableName": "statusColumnId"
    }
  ],
  "concreteType": "MondayItemPreviewNode",
  "kind": "LinkedField",
  "name": "itemPreview",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "due",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "done",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "assignee",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MondayImportExistingTicketPanePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MondayUserNode",
                "kind": "LinkedField",
                "name": "monday",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "MondayImportExistingTicketPanePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MondayUserNode",
                "kind": "LinkedField",
                "name": "monday",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ce56282603771fb6ac8a02f5c93cfbdf",
    "id": null,
    "metadata": {},
    "name": "MondayImportExistingTicketPanePreviewQuery",
    "operationKind": "query",
    "text": "query MondayImportExistingTicketPanePreviewQuery(\n  $itemId: String!\n  $assigneeColumnId: String\n  $dueDateColumnId: String\n  $statusColumnId: String\n) {\n  viewer {\n    integrations {\n      monday {\n        itemPreview(itemId: $itemId, assigneeColumnId: $assigneeColumnId, dueDateColumnId: $dueDateColumnId, statusColumnId: $statusColumnId) {\n          id\n          name\n          externalId\n          due\n          done\n          assignee {\n            id\n            fullName\n            image\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9cc9b2aad2560d65cffc8f9eeee82529";

export default node;
